import { Button, Card, useTheme } from '@mui/material';

import TicketHeaderSkeleton from '../TicketHeaderSkeleton';

import { ArrowBackIos } from '@mui/icons-material';

import { getStyled } from './styles';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { TicketsContext } from '../../context/Tickets/TicketsContext';

const TicketHeader = ({ loading, children }) => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const navigate = useNavigate();
  const { setCurrentTicket } = useContext(TicketsContext);

  const handleBack = () => {
    setCurrentTicket({ id: null, uuid: null, code: null });
    navigate('/tickets');
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card square sx={classes.ticketHeader}>
          <Button sx={classes.button} onClick={handleBack}>
            <ArrowBackIos sx={classes.icon} />
          </Button>
          {children}
        </Card>
      )}
    </>
  );
};

export default TicketHeader;
